<template>
  <div>
    <!-- Info modal -->
    <b-modal v-model="modalShow" ref="modalConfEdit"
            size="xl" 
            title="Editar configuracion" 
            ok-only
            ok-title="Guardar"
            :hide-footer="!isUserAdmin()"
            @ok="handleOk"
            @hide="resetInfoModal">
        
      <!-- INIT FORMULARIO -->
      <b-form ref="form" @submit.stop.prevent="handleSubmit" v-if="this.configuration">     
        <!-- Fila 1 -->
        <b-row>
          <b-col>
            <b-form-group  label-size="sm" label="Limite superior *" label-for="upperLimit">
              <b-form-input type="number" step="any" id="upperLimit" :state="valUpperLimit" size="sm" placeholder="..." v-model="configuration.upperLimit" min="0" max="100" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group  label-size="sm" label="Limite inferior *" label-for="lowerLimit">
              <b-form-input type="number" step="any" id="lowerLimit" :state="valLowerLimit" size="sm" placeholder="..." v-model="configuration.lowerLimit" min="0" max="45" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group  label-size="sm" label="Window *" label-for="window">
              <b-form-input type="number" step="any" id="window" size="sm" :state="valWindow" placeholder="..." v-model="configuration.window" min="4" max="9" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group  label-size="sm" label="Slope *" label-for="slope">
              <b-form-input type="number" step="any" id="slope" size="sm" :state="valSlope" placeholder="..." v-model="configuration.slope" min="4" max="8" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>                                 

        <!-- Fila 2 -->
        <b-row>
          <b-col>
            <b-form-group  label-size="sm" label="Threshold Short *" label-for="thresholdShort">
              <b-form-input type="number" step="any" id="thresholdShort" size="sm" :state="valThresholdShort" placeholder="..." v-model="configuration.thresholdShort" min="1" max="1000" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group  label-size="sm" label="Saturation *" label-for="saturation">
              <b-form-input type="number" step="any" id="saturation" size="sm" :state="valSaturation" placeholder="..." v-model="configuration.saturation" min="1" max="150" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group  label-size="sm" label="Max Count *" label-for="maxCount">
              <b-form-input type="number" step="any" id="maxCount" size="sm" :state="valMaxCount" placeholder="..." v-model="configuration.maxCount" min="1" max="150" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group  label-size="sm" label="Threshold Gathering *" label-for="thresholdGathering">
              <b-form-input type="number" step="any" id="thresholdGathering" size="sm" :state="valThresholdGathering" placeholder="..." v-model="configuration.thresholdGathering" min="1" max="1000" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row> 

        <!-- Fila 3 -->
        <b-row>
          <b-col>
            <small>* El campo debe ser rellenado</small><br>
          </b-col>
          <!--spacer -->
          <b-col class="col-sm-1 col-xs-1"/>
        </b-row>
      </b-form>
      <!-- END FORMULARIO -->
      
    </b-modal>

  </div>
</template>


<script>
import BitacoraService from "@/services/BitacoraService";
import ConfigurationService from "@/services/ConfigurationService";
import UserService from '@/services/UserService';

export default {
  name: "edit-configuration-modal",
  data() {
    return {
      configuration: null,
      submitted: false,
      disabledInput: false,
      modalShow: false
    };
  },
  computed: {
    valUpperLimit() {
      return ((this.configuration.upperLimit <= 100) && (this.configuration.upperLimit >= 50))? true : false
    },
    valLowerLimit() {
      return ((this.configuration.lowerLimit <= 45) && (this.configuration.lowerLimit >= 0))? true : false
    },
    valWindow() {
      return ((this.configuration.window <= 9) && (this.configuration.window >= 4))? true : false
    },
    valSlope() {
      return ((this.configuration.slope <= 8) && (this.configuration.slope >= 4))? true : false
    },
    valThresholdShort() {
      return ((this.configuration.thresholdShort <= 1000) && (this.configuration.thresholdShort >= 1))? true : false
    },
    valSaturation() {
      return ((this.configuration.saturation <= 150) && (this.configuration.saturation >= 1))? true : false
    },
    valMaxCount() {
      return ((this.configuration.maxCount <= 150) && (this.configuration.maxCount >= 1))? true : false
    },
    valThresholdGathering() {
      return ((this.configuration.thresholdGathering <= 1000) && (this.configuration.thresholdGathering >= 1))? true : false
    }                
  },  
  methods: {

    showModal(pConfiguration){
      this.configuration = pConfiguration;
      this.modalShow = true;
      this.$refs['modalConfEdit'].show();
    },
    
    resetInfoModal() {
      //this.configuration = null;
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }

      // save form
      this.saveConfiguration();
      this.modalShow = false;
    },

    checkFormValidity() {
      const valid = this.$refs.form.reportValidity()
      //Check inputs to validate



      //this.nameState = valid
      return valid
    },

    saveConfiguration() {
      ConfigurationService.updateConfiguration(this.configuration)
        .then(response => {
          this.getConfiguration();
          //Mensaje de actualización
          this.$notify({
             group: 'notificateDiv',
             type: 'success',
             title: response.data.message ? response.data.message : 'Configuración modificada correctamente',
             text: response.data.message ? "" : 'Se ha modificado la configuración seleccionada',
             duration: 3000,
             speed: 1000
          });
          //LOGS
          BitacoraService.write("INFO", "Configuracion: Se ha modificado 1 configuración de la lista")
          //delay antes de rehabilitarlos
          setTimeout(()=>{
            //Avisamos al parent de que cambie componente
            this.disabledInput = false;
          },500);
          //Refresh table list (parent signal)
          this.$emit('onClickSave')

        })
        .catch(e => {
          console.log(e);
          //Mensaje de actualización
          this.$notify({
             group: 'notificateDiv',
             type: 'pepito',
             title: 'Error al guardar los cambios',
             text: 'No se han podido almacenar los cambios solicitados',
             duration: 3000,
             speed: 1000
          });
           //LOGS
          BitacoraService.write("ERROR", "Configuracion: No se ha podido modificar 1 configuración de la lista")         
        });
        //Rehabilitiamso lso botones de nuevo
        this.disabledInput = false;
    },  

    getConfiguration() {
      ConfigurationService.getConfiguration()
        .then(response => {
          this.configuration = response.data  
        })
        .catch(e => {
          console.log(e);
        });
    },

    isUserAdmin(){
      return UserService.isUserAdmin();
    }
  },
  mounted() {
    this.getConfiguration();
  }
};
</script>

<style scoped>

.groupBox{
  border: 1px solid rgba(0,0,0,.0625);
  border-radius:3px;
  padding:30px;
  margin-left:30px;
  margin-right:30px;
}

</style>